import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import SubmitButton from "../StyledComponents/SubmitButton";
import { useTranslation } from "../../i18n/TranslationProvider";
import { translateSymptom } from "../../i18n/translateData";

// Medical safety content: keys live under "medicalSafety." and are SKIPPED by the
// translation generator, so non-reviewed languages fall back to English.
// Only add a language here after clinical/professional review.
const ADULT_SIGNS = [
  "severeHeadache",
  "consciousnessChange",
  "discoloration",
  "breathing",
  "confusion",
  "balance",
  "weakness",
  "pupils",
  "slurredSpeech",
  "seizures",
  "bleeding",
  "fluidLeakage",
];
const CHILD_SIGNS = ["crying", "refusalToEat", "bulging", "vomiting"];

const Warning = ({ user }) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const symptom = location.state.symtom;

  if (!user || !symptom) history.goBack();

  // `symptom` is the English factor from the DB; translate for display only
  const symptomLabel = translateSymptom(t, symptom);

  return (
    <>
      <h3>{t("medicalSafety.warning.greeting", { name: user.firstName })}</h3>
      <p>{t("medicalSafety.warning.intro", { symptom: symptomLabel })}</p>
      <p>{t("medicalSafety.warning.informCaregiver")}</p>
      <p>{t("medicalSafety.warning.seriousCondition")}</p>
      <p>{t("medicalSafety.warning.emergency")}</p>

      <h3>{t("medicalSafety.warning.adultsHeader")}</h3>
      <ul>
        {ADULT_SIGNS.map((key) => (
          <li key={key}>{t(`medicalSafety.warning.adultSigns.${key}`)}</li>
        ))}
      </ul>

      <h3>{t("medicalSafety.warning.childrenHeader")}</h3>
      <span>{t("medicalSafety.warning.childrenIntro")} </span>
      <ul>
        {CHILD_SIGNS.map((key) => (
          <li key={key}>{t(`medicalSafety.warning.childSigns.${key}`)}</li>
        ))}
      </ul>
      <SubmitButton onClick={() => history.push("/")}>{t("dashboard.goBack")}</SubmitButton>
    </>
  );
};

export default Warning;